import React, { useState } from 'react';

const PrivateLtdCompany = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Private Ltd Company registration.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

 const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Private Ltd Company registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Private Ltd Company Registration
            </h1>
            <p className="mt-4 text-xl text-blue-100">
              The ideal structure for startups and businesses with high growth and capital-raising aspirations.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">💼</span> Start Company Registration Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Private Limited Company (PLC)
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Setting up a <strong>Private Limited Company</strong> is one of the highly recommended ways to start a business in India. Start-ups and businesses with higher growth aspirations popularly prefer this structure, which is governed by the Companies Act, 2013, and the Ministry of Corporate Affairs (MCA). A PLC requires a minimum of 2 directors and 2 members, and a maximum of 50 members.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                A Private Company has restricted the right of a member to transfer its shares and must have a minimum paid-up capital of Re. 1. This structure provides the perfect combination of corporate governance and limited liability, making it a globally recognized and preferred business vehicle.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Limited Liability:</strong> Personal assets of the directors/shareholders are protected from the company's debts.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Separate Legal Entity:</strong> The company exists independently of its owners, capable of holding assets and engaging in contracts.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Perpetual Succession:</strong> The life of the company is continuous, unaffected by the death or exit of any member.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Access to Funding:</strong> This structure makes it easier to raise capital from venture capitalists, banks, and angel investors.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Easy Transferability:</strong> Shares can be easily transferred to another party, subject to articles of association.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Private Ltd Company registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Simple Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Private Limited Company Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 grid-flow-row-dense">
            {[
              { number: "01", icon: "📊", title: "KYC & Initial Consultation", desc: "Raise query, submit KYC documents of directors, and make 50% advance payment." },
              { number: "02", icon: "🔒", title: "Procure DSC & DIN", desc: "Application for Digital Signature Certificate (DSC) and Director Identification Number (DIN)." },
              { number: "03", icon: "🏢", title: "Name Reservation (SPICe+)", desc: "Filing for reservation of the company name with the Ministry of Corporate Affairs (MCA)." },
              { number: "04", icon: "📜", title: "Drafting Documents", desc: "Preparation of Memorandum (MoA) & Articles (AoA) of Association drafts and statutory declarations." },
              { number: "05", icon: "✍️", title: "Signing & Balance Payment", desc: "Documents are signed by the directors/subscribers and the balance 50% payment is made." },
              { number: "06", icon: "✅", title: "Filing Incorporation Form", desc: "Final submission of the comprehensive incorporation form (SPICe+ Part B) with all annexures." },
              { number: "07", icon: "🖋️", title: "Issuance of Certificate", desc: "The Registrar of Companies (ROC) issues the Certificate of Incorporation (CoI)." },
              { number: "08", icon: "📬", title: "Final Document Delivery", desc: "Delivery of CoI, MoA, AoA, PAN, TAN and assistance with zero-balance bank account opening." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 p-4 bg-white rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow border-t-4 border-blue-500 h-full">
                <div className="procedure-step-content">
                  <div>
                    <span className="text-2xl font-extrabold text-blue-600 block mb-2">{step.number}</span>
                    <span className="text-2xl mx-auto mb-2 block">{step.icon}</span>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm mt-3">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Private Limited Company
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "Directors' KYC & Photo", desc: "PAN Card, Aadhar Card/Voter ID/Passport copy, and passport size photograph of all proposed directors/subscribers." },
              { icon: "📍", title: "Directors' Address Proof", desc: "Bank Statement/Mobile Bill/Electricity Bill for all directors. (Must be less than 30 Days old)." },
              { icon: "🏢", title: "Registered Office Proof", desc: "Rent agreement/Sale Deed, NOC from the owner, and latest Utility Bill (must be less than 30 days old)." },
              { icon: "🛂", title: "Passport for NRI/Foreigners", desc: "Mandatory copy of Passport for any Non-resident Director or Subscriber, duly apostilled/attested." },
              { icon: "📄", title: "Consent Forms & Declarations", desc: "Directors' Consent (DIR-2), Declarations from all subscribers, and optional educational certificates." },
              { icon: "💼", title: "Proposed Company Details", desc: "Two preferred names for the company and a detailed description of the main business objective." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: "📋", title: "Certificate of Incorporation", desc: "The official legal document issued by the ROC certifying the company's existence." },
              { icon: "📚", title: "MoA & AoA", desc: "The Memorandum and Articles of Association (Charter documents) of the company." },
              { icon: "🆔", title: "Company PAN and TAN", desc: "The Permanent Account Number and Tax Deduction Account Number for the company." },
              { icon: "💳", title: "Zero Balance A/c & DSCs", desc: "Assistance with opening a zero-balance current account & delivery of DSCs/DINs for two directors." }
            ].map((item, index) => (
              <div key={index} className="p-6 bg-white rounded-xl shadow-lg border-l-4 border-green-500 h-full flex flex-col">
                <span className="text-2xl mb-3 block">{item.icon}</span>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Common Questions
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Private Ltd Company FAQs
            </p>
          </div>
          
          <div className="space-y-4 max-w-4xl mx-auto">
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">What is the minimum requirement for Directors and Members?</h4>
              <p className="text-gray-600">A Private Limited Company requires a minimum of <strong>two directors</strong> and <strong>two shareholders/members</strong>. At least one director must be a resident of India.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">How long does it take to complete the registration process?</h4>
              <p className="text-gray-600">The company registration typically takes <strong>3-4 working days</strong> after receiving all the required documents. GST registration, if needed, takes an additional 5-7 working days.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">Can a Foreign Resident or NRI become a Director?</h4>
              <p className="text-gray-600">Yes, a foreign resident or NRI/PIO can be a director. However, their identity and address proofs (like passport copy) must be <strong>duly attested</strong> by the Indian Embassy or an apostille authority in their country.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">Is an official office address required for registration?</h4>
              <p className="text-gray-600">Yes, a registered office address is mandatory. However, you can initially use a <strong>residential address</strong> (like a director's home) as the registered office, provided a No-Objection Certificate (NOC) from the owner and a utility bill are submitted.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white">
            Ready to Form Your Private Limited Company?
          </h2>
          <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
            Our experts will guide you through the seamless registration process with a fixed, affordable fee.
          </p>
          <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
            <span className="mr-2">📞</span> Consult Our Expert Today
          </a>
        </div>
      </section>
    </main>
  );
};

export default PrivateLtdCompany;